{
  "ru": {
    "brand": {
      "name": "kreditiem.lv | Apdrošināšana",
      "legal_name": "AS Baltijas investīciju un attīstības fonds",
      "tagline": "Страхование в сотрудничестве с Balcia Insurance",
      "broker_label": "Партнёр Balcia Insurance",
      "description": "Страхование в сотрудничестве с Balcia Insurance. Помогаем частным лицам и компаниям выбрать и оформить подходящее решение.",
      "email": "info@kreditiem.lv",
      "phone": "+371 20865183",
      "phone_e164": "+37120865183",
      "working_hours": "Понедельник–пятница: 8:00–18:00",
      "address": "Bukultu iela 11, Рига, Латвия",
      "street_address": "Bukultu iela 11",
      "postal_code": "LV-1024",
      "address_locality": "Рига",
      "address_country": "LV",
      "registration_number": 40003000000,
      "opening_hours": "Mo-Fr 08:00-18:00"
    },
    "form": {
      "other_slug": "other",
      "other_label": "Другое",
      "insurance_types": {
        "octa": "ОСТА",
        "kasko": "КАСКО",
        "home": "Жильё",
        "travel": "Путешествия",
        "health": "Здоровье",
        "accident": "Несчастные случаи",
        "liability": "Гражданская ответственность",
        "employee": "Сотрудники",
        "commercial_real_estate": "Коммерческая недвижимость",
        "Freight": "Грузы",
        "company": "Компания",
        "other": "Другое"
      }
    },
    "breadcrumbs": {
      "home": "Главная",
      "blog": "Блог",
      "private_persons": "Частным лицам",
      "businesses": "Компаниям"
    },
    "cookie_consent": {
      "accept": "Принять все",
      "decline": "Отклонить",
      "message": "Мы используем файлы cookie для улучшения вашего опыта просмотра, предоставления персонализированного контента и анализа нашего трафика. Нажимая «Принять все», вы соглашаетесь на использование нами файлов cookie.",
      "privacy_policy": "Прочитайте нашу Политику конфиденциальности",
      "settings": "Настройки cookie"
    },
    "insurance_products": {
      "show": {
        "private_breadcrumb": "Частным лицам",
        "business_breadcrumb": "Компаниям"
      }
    },
    "meta": {
      "home": {
        "title": "%{brand} — %{tagline}",
        "description": "%{description}"
      },
      "private_persons": {
        "title": "Страхование для частных лиц — ОСТА, КАСКО, жильё, поездки | %{brand}",
        "description": "Страховое предложение для частных лиц: ОСТА, КАСКО, страхование жилья, поездок, здоровья и несчастных случаев."
      },
      "businesses": {
        "title": "Страхование для компаний — имущество, ответственность, сотрудники, грузы | %{brand}",
        "description": "Страховые решения для бизнеса: коммерческая недвижимость, гражданская ответственность, здоровье сотрудников, грузы и транспорт."
      },
      "blogs": {
        "title": "Блог о страховании — советы и пояснения | %{brand}",
        "description": "Статьи о страховании: как выбрать ОСТА и КАСКО, что покрывает страхование жилья, как подать заявление на выплату и советы для компаний."
      },
      "blog_category": {
        "title": "%{name} — статьи и советы | %{brand}"
      },
      "application": {
        "title": "Подать заявку на страхование — получите предложение | %{brand}",
        "description": "Заполните одну заявку и получите страховое предложение. Бесплатная консультация для частных лиц и компаний."
      },
      "contacts": {
        "title": "Контакты — свяжитесь со страховым консультантом | %{brand}",
        "description": "Свяжитесь с %{brand}: %{phone}, %{email}. %{working_hours}."
      },
      "not_found": {
        "title": "Страница не найдена | %{brand}",
        "description": "К сожалению, эта страница не найдена. Вернитесь на главную или свяжитесь с нами."
      }
    },
    "home": {
      "hero": {
        "title": "Получите страховое предложение",
        "subtitle": "Заполните одну заявку, и наш страховой консультант подготовит предложение. Консультация бесплатна — решение принимаете только вы.",
        "highlights": [
          "Одна заявка — одно предложение",
          "Бесплатная консультация со страховым консультантом",
          "Ответ в течение одного рабочего дня"
        ],
        "stats": [
          {
            "value": "Balcia",
            "label": "Страховой партнёр"
          },
          {
            "value": "4 мин",
            "label": "Среднее время заполнения заявки"
          },
          {
            "value": "9 000+",
            "label": "Подготовленных предложений"
          }
        ]
      },
      "advantages": [
        {
          "icon": "layers",
          "title": "Предложение в одной заявке",
          "description": "Заполните заявку, и мы подготовим страховое предложение, которое подходит вашей ситуации."
        },
        {
          "icon": "bolt",
          "title": "Быстрое рассмотрение заявки",
          "description": "Заполнение формы занимает несколько минут, а предложение обычно готовим в течение одного рабочего дня."
        },
        {
          "icon": "gift",
          "title": "Бесплатная консультация",
          "description": "За консультацию вам платить не нужно. Мы объясняем условия понятным языком, в том числе мелкий шрифт."
        },
        {
          "icon": "user-check",
          "title": "Персональный страховой консультант",
          "description": "У вас один контакт — и при выборе полиса, и позже, если нужно подать заявление на выплату."
        }
      ],
      "steps": [
        {
          "title": "Заполните заявку",
          "description": "Укажите, что хотите застраховать, и свои контакты. Сложные вопросы можно оставить нашему консультанту."
        },
        {
          "title": "Консультант готовит предложение",
          "description": "Проверяем, что покрытие подходит вашей ситуации, и готовим страховое предложение."
        },
        {
          "title": "Получите предложение",
          "description": "Отправляем предложение с ценой и покрытием. Когда выберете, полис оформим удалённо."
        }
      ],
      "testimonials": [
        {
          "name": "Ilze K.",
          "role": "Рига, страхование жилья",
          "quote": "Консультант объяснил, что входит в полис. Я выбрала предложение, которое покрывало протечку воды.",
          "rating": 5
        },
        {
          "name": "Māris B.",
          "role": "Елгава, ОСТА и КАСКО",
          "quote": "Раньше ОСТА покупал в последний день, не задумываясь. В этот раз получил понятное предложение и оформил полис вовремя.",
          "rating": 5
        },
        {
          "name": "Anete S.",
          "role": "Руководитель SIA, страхование сотрудников",
          "quote": "Нужно было медицинское страхование для 14 сотрудников. Консультант подготовил предложение, которое я смогла показать правлению.",
          "rating": 5
        }
      ],
      "faq": [
        {
          "question": "Сколько стоит консультация?",
          "answer": "Подготовка заявки и консультация для вас бесплатны. Вознаграждение консультанту платит страховщик, поэтому цена полиса не выше, чем при покупке напрямую."
        },
        {
          "question": "Как быстро я получу предложение?",
          "answer": "По простым продуктам, например ОСТА или страхованию поездок, предложение обычно отправляем в течение нескольких часов в рабочий день. Для страхования компании может понадобиться два-три рабочих дня."
        },
        {
          "question": "Обязан ли я принять предложение?",
          "answer": "Нет. Предложение информационное, и у вас нет обязанности его принимать. Если оно не подходит, можем уточнить потребности или прекратить переписку."
        },
        {
          "question": "Какие данные вы храните?",
          "answer": "Храним только информацию, необходимую для подготовки предложения, и передаём её страховщику. Данные можно попросить удалить в любой момент."
        },
        {
          "question": "Можете ли вы помочь, если произошёл страховой случай?",
          "answer": "Да. Помогаем понять, какие документы нужны, и связываемся со страховщиком, если процесс выплаты затягивается."
        },
        {
          "question": "Можно ли застраховать несколько вещей в одной заявке?",
          "answer": "В заявке выберите основной вид страхования, а остальное укажите в комментариях. Консультант подготовит общее предложение, где часто можно получить скидку за несколько продуктов."
        }
      ],
      "sections": {
        "products": {
          "eyebrow": "Виды страхования",
          "title": "Выберите, что хотите застраховать",
          "subtitle": "У каждого вида своя страница, где мы объясняем покрытие, исключения и как формируется цена."
        },
        "advantages": {
          "eyebrow": "Почему мы",
          "title": "Консультант работает в ваших интересах, а не страховщика"
        },
        "steps": {
          "eyebrow": "Как это происходит",
          "title": "Три шага до предложения"
        },
        "faq": {
          "eyebrow": "Частые вопросы",
          "title": "Ответы на то, о чём клиенты спрашивают чаще всего"
        },
        "blog": {
          "eyebrow": "Блог",
          "title": "Полезные статьи о страховании"
        }
      }
    },
    "contacts": {
      "intro": "Пишите или звоните — отвечаем в рабочие дни. Если нужно предложение, быстрее всего заполнить заявку: тогда мы сразу видим необходимую информацию.",
      "channels": [
        {
          "icon": "phone",
          "label": "Телефон",
          "value": "+371 20865183",
          "href": "tel:+37120865183",
          "note": "Понедельник–пятница: 8:00–18:00"
        },
        {
          "icon": "mail",
          "label": "Эл. почта",
          "value": "info@kreditiem.lv",
          "href": "mailto:info@kreditiem.lv",
          "note": "Отвечаем в течение 1 рабочего дня"
        },
        {
          "icon": "map-pin",
          "label": "Офис",
          "value": "Bukultu iela 11, Рига, Латвия",
          "note": "Встречи по предварительной договорённости"
        }
      ],
      "notes": [
        {
          "title": "Рассмотрение заявок",
          "description": "Заявки принимаем круглосуточно, но обрабатываем в рабочее время. В срочных случаях — например, если ОСТА заканчивается сегодня — звоните."
        },
        {
          "title": "Вопросы по выплатам",
          "description": "Если произошёл страховой случай, сначала сообщите страховщику, затем нам — поможем с документами и коммуникацией."
        }
      ],
      "page": {
        "title": "Свяжитесь с нами",
        "channels_title": "Способы связи",
        "notes_title": "Полезно знать",
        "details_title": "Реквизиты",
        "name": "Название",
        "registration_number": "Регистрационный номер",
        "address": "Адрес",
        "working_hours": "Рабочее время",
        "cta_title": "Хотите предложение без разговора?",
        "cta_description": "Заполните заявку, и мы ответим страховым предложением."
      }
    },
    "audiences": {
      "private": {
        "heading": "Страхование для частных лиц",
        "subheading": "Выберите вид страхования и получите предложение в одной заявке."
      },
      "business": {
        "heading": "Страхование для компаний",
        "subheading": "От коммерческой недвижимости до здоровья сотрудников — подготовим предложение под риски вашей отрасли."
      },
      "sections": {
        "products_private": "Виды страхования для частных лиц",
        "products_business": "Виды страхования для компаний",
        "products_subtitle": "На каждой странице — покрытие, исключения, ориентировочные цены и частые вопросы.",
        "steps_title": "Как проходит заявка",
        "advantages_title": "Что вы получаете, работая с консультантом",
        "faq_title": "Частые вопросы"
      }
    },
    "categories": {
      "auto": {
        "name": "Автострахование",
        "description": "ОСТА, КАСКО и всё, что нужно знать об автостраховании в Латвии.",
        "position": 1
      },
      "majoklis": {
        "name": "Страхование жилья",
        "description": "Страхование домов, квартир и домашнего имущества понятным языком.",
        "position": 2
      },
      "celojumi": {
        "name": "Страхование путешествий",
        "description": "Что покрывает полис, как действовать за границей и как выбрать покрытие.",
        "position": 3
      },
      "veseliba": {
        "name": "Медицинское страхование",
        "description": "Страхование здоровья и несчастных случаев для частных лиц и семей.",
        "position": 4
      },
      "uznemumiem": {
        "name": "Страхование компаний",
        "description": "Управление рисками для бизнеса: имущество, перерывы, сотрудники и грузы.",
        "position": 5
      },
      "atbildiba": {
        "name": "Гражданская ответственность",
        "description": "Когда страхование ответственности обязательно, а когда просто разумно.",
        "position": 6
      },
      "atlidzibas": {
        "name": "Выплаты",
        "description": "Как подать заявление на выплату, какие документы нужны и почему отказывают.",
        "position": 7
      },
      "padomi": {
        "name": "Советы по страхованию",
        "description": "Практические советы, как выбрать покрытие и не платить за лишнее.",
        "position": 8
      }
    },
    "category_order": [
      "auto",
      "majoklis",
      "celojumi",
      "veseliba",
      "uznemumiem",
      "atbildiba",
      "atlidzibas",
      "padomi"
    ],
    "product_order": [
      "octa",
      "kasko",
      "majokla-apdrosinasana",
      "celojumu-apdrosinasana",
      "veselibas-apdrosinasana",
      "nelaimes-gadijumu-apdrosinasana",
      "civiltiesiska-atbildiba",
      "darbinieku-apdrosinasana",
      "komercipasuma-apdrosinasana",
      "kravu-apdrosinasana",
      "uznemumu-apdrosinasana"
    ],
    "blog_order": [
      "pasrisks-ka-izveleties",
      "ka-ietaupit-uz-apdrosinasanu",
      "kapec-atsaka-atlidzibu",
      "ka-pieteikt-atlidzibu",
      "kravu-apdrosinasana-vai-pietiek-ar-parvadataju",
      "komercipasuma-apdrosinasana-noliktavai",
      "uznemuma-apdrosinasana-ar-ko-sakt",
      "profesionala-atbildiba-pakalpojumiem",
      "civiltiesiska-atbildiba-uznemumiem",
      "nelaimes-gadijumu-apdrosinasana-berniem",
      "veselibas-polise-ko-tiesi-sedz",
      "veselibas-apdrosinasana-darbiniekiem",
      "celojumu-apdrosinasana-ziemas-sportam",
      "evak-karte-vai-celojumu-polise",
      "celojumu-apdrosinasana-eiropa",
      "ka-noteikt-apdrosinajuma-summu",
      "udens-noplude-dzivokli",
      "ko-sedz-majokla-apdrosinasana",
      "bonus-malus-sistema",
      "kasko-vai-octa",
      "ka-izveleties-octa"
    ],
    "page_order": [
      "lietosanas-noteikumi",
      "privatuma-politika",
      "sikdatnu-politika"
    ],
    "products": {
      "octa": {
        "name": "ОСТА",
        "short_name": "ОСТА",
        "tagline": "Обязательное страхование гражданской ответственности автовладельца",
        "summary": "Предусмотренный законом полис, который покрывает ущерб, причинённый другим с транспортным средством. Без него ездить по Латвии нельзя."
      },
      "kasko": {
        "name": "КАСКО",
        "short_name": "КАСКО",
        "tagline": "Добровольное страхование транспортного средства",
        "summary": "Покрывает повреждения вашего автомобиля — при столкновении, краже, пожаре или стихийном бедствии. Покрытие и франшизу выбираете вы."
      },
      "majokla-apdrosinasana": {
        "name": "Страхование жилья",
        "short_name": "Жильё",
        "tagline": "Защита квартиры и частного дома",
        "summary": "Покрывает конструкции, внутреннюю отделку и домашнее имущество квартиры или дома — от протечки воды до бури и пожара."
      },
      "celojumu-apdrosinasana": {
        "name": "Страхование путешествий",
        "short_name": "Путешествия",
        "tagline": "Медицинская помощь и риски поездки за границей",
        "summary": "Покрывает неотложную медицинскую помощь за границей, утрату багажа и отмену поездки. Разовый полис на одну поездку или годовой полис."
      },
      "veselibas-apdrosinasana": {
        "name": "Медицинское страхование",
        "short_name": "Здоровье",
        "tagline": "Более быстрый доступ к врачам и обследованиям",
        "summary": "Покрывает визиты к семейному врачу и специалистам, обследования, стоматологию и лекарства согласно выбранной программе."
      },
      "nelaimes-gadijumu-apdrosinasana": {
        "name": "Страхование от несчастных случаев",
        "short_name": "Несчастные случаи",
        "tagline": "Денежная выплата при травме или нетрудоспособности",
        "summary": "Выплачивает фиксированную сумму при травме, нетрудоспособности или инвалидности. Действует 24 часа в сутки, в том числе в свободное время и в спорте."
      },
      "civiltiesiska-atbildiba": {
        "name": "Страхование гражданской ответственности",
        "short_name": "Ответственность",
        "tagline": "Покрывает ущерб, причинённый другим",
        "summary": "Возмещает третьим лицам имущественный и личный ущерб, включая юридические расходы, если против вас выдвинуто требование."
      },
      "darbinieku-apdrosinasana": {
        "name": "Страхование сотрудников",
        "short_name": "Сотрудники",
        "tagline": "Покрытие здоровья и несчастных случаев для коллектива",
        "summary": "Пакет льгот для сотрудников: медицинское страхование, несчастные случаи и страхование жизни с налоговыми льготами в пределах закона."
      },
      "komercipasuma-apdrosinasana": {
        "name": "Страхование коммерческой недвижимости",
        "short_name": "Коммерческая недвижимость",
        "tagline": "Офисы, производства, склады и торговые помещения",
        "summary": "Покрывает здания коммерческих площадей, отделку, оборудование и запасы, а также упущенную прибыль, если деятельность временно приходится остановить."
      },
      "kravu-apdrosinasana": {
        "name": "Страхование грузов",
        "short_name": "Грузы",
        "tagline": "Защита товаров во время перевозки",
        "summary": "Покрывает повреждение, кражу и гибель груза при перевозке автотранспортом, морем, воздухом или железной дорогой — независимо от лимитов ответственности перевозчика."
      },
      "uznemumu-apdrosinasana": {
        "name": "Страхование компаний",
        "short_name": "Компания",
        "tagline": "Комплексное решение рисков предприятия",
        "summary": "Один договор, объединяющий имущество, ответственность, сотрудников и перерыв в деятельности. Подходит малым и средним компаниям, которым не нужны отдельные полисы."
      }
    },
    "ui": {
      "skip_to_content": "Перейти к содержанию",
      "optional": "необязательно",
      "locales": {
        "lv": "Latviešu",
        "en": "English",
        "ru": "Русский"
      },
      "locale_switcher": {
        "label": "Язык"
      },
      "nav": {
        "main": "Основная навигация",
        "mobile": "Мобильная навигация",
        "open": "Открыть меню",
        "close": "Закрыть меню",
        "private": "Частным лицам",
        "business": "Компаниям",
        "blog": "Блог",
        "contacts": "Контакты",
        "financing": "Финансирование",
        "apply": "Подать заявку"
      },
      "logo": {
        "home": "%{brand} — главная страница",
        "descriptor": "страхование"
      },
      "footer": {
        "private": "Частным лицам",
        "business": "Компаниям",
        "blog": "Блог",
        "legal": "Юридическая информация",
        "copyright": "© %{year} %{name}. Все права защищены.",
        "disclaimer": "Объём полномочий — сотрудничество с Balcia Insurance. Договор страхования заключается со страховой компанией.",
        "privacy": "Политика конфиденциальности",
        "cookies": "Политика файлов cookie",
        "terms": "Условия использования"
      },
      "cta": {
        "apply": "Подать заявку",
        "learn_more": "Узнать больше",
        "get_offer": "Получить предложение",
        "all_posts": "Все статьи",
        "title": "Получите страховое предложение",
        "description": "Заполните заявку за несколько минут, и консультант подготовит страховое предложение. Консультация бесплатна.",
        "call": "Позвонить %{phone}"
      },
      "home": {
        "all_posts": "Все статьи",
        "apply": "Подать заявку",
        "learn_more": "Узнать больше",
        "step": "Шаг %{n}."
      },
      "product": {
        "benefits_title": "Что даёт страхование %{name}",
        "coverage_title": "Что покрывается и что нет",
        "covered": "Обычно покрывается",
        "not_covered": "Обычно не покрывается",
        "coverage_note": "Точное покрытие определяют условия полиса конкретного страховщика, которые вы получите перед покупкой.",
        "pricing_title": "Сколько это стоит",
        "price_factors": "Что влияет на цену",
        "faq_title": "Частые вопросы",
        "related": "Часто выбирают также",
        "cta_title": "Получите предложение по %{name}",
        "get_offer": "Получить предложение"
      },
      "blog": {
        "title": "Блог о страховании",
        "subtitle": "Пояснения и советы, которые помогают выбрать нужное покрытие и не платить за лишнее.",
        "all_posts": "Все статьи",
        "categories": "Категории блога",
        "empty": "В этой категории пока нет статей. Смотрите",
        "empty_link": "все статьи",
        "reading_time": "%{count} мин чтения",
        "article": "Статья",
        "topics": "Темы",
        "related_offer_title": "Хотите предложение по %{name}?",
        "about_product": "О %{name}",
        "get_offer": "Получить предложение",
        "disclaimer": "Статья носит информационный характер и не заменяет условия договора страхования. Если есть вопросы, %{link}.",
        "contact_us": "свяжитесь с нами",
        "related_posts": "Другие статьи в этой категории"
      },
      "static": {
        "updated": "Обновлено:"
      },
      "not_found": {
        "title": "Страница не найдена",
        "body": "Возможно, ссылка устарела или в адресе ошибка. Начните с главной страницы или заполните заявку — мы свяжемся с вами.",
        "home": "На главную",
        "apply": "Подать заявку на страхование",
        "or_call": "Или позвоните:"
      },
      "error": {
        "title": "Не удалось показать эту страницу",
        "body": "Ошибка на нашей стороне. Обновите страницу или свяжитесь с нами — заявку можем принять и по телефону.",
        "reload": "Обновить страницу",
        "contacts": "Контакты"
      },
      "application": {
        "title": "Заявка на страховое предложение",
        "subtitle": "Заполнение занимает около 3 минут. Заявка ни к чему не обязывает.",
        "hero_title": "Подать заявку сейчас",
        "how_we_work": "Как мы работаем",
        "need_help": "Нужна помощь с заполнением?",
        "disclaimer": "Отправляя заявку, вы не покупаете полис — сначала получите предложение для оценки.",
        "success_title": "Заявка получена",
        "success_body": "Консультант оценит ваши потребности и свяжется в течение одного рабочего дня — по телефону или на %{email}.",
        "reference": "Номер заявки:",
        "home": "На главную",
        "read_blog": "Читать блог",
        "next": "Далее",
        "back": "Назад",
        "submit": "Получить страховое предложение",
        "submit_hero": "Получить предложение",
        "submitting": "Отправка…",
        "call_also": "Можете также позвонить: %{phone}.",
        "submit_error": "Не удалось отправить заявку",
        "step_of": "Шаг %{current} из %{total}",
        "step_aria": "Шаг заявки %{current} из %{total}",
        "validation_error": "В заявке есть ошибки",
        "rate_limit": "Слишком много запросов. Пожалуйста, попробуйте позже или позвоните нам.",
        "server_error": "Не удалось связаться с сервером. Пожалуйста, попробуйте ещё раз.",
        "trust": [
          "Готовим страховое предложение",
          "Консультация и подготовка заявки бесплатны",
          "Отвечаем в течение одного рабочего дня",
          "Данные используем только для подготовки предложения"
        ],
        "steps": {
          "applicant": "Тип заявителя",
          "insurance": "Вид страхования",
          "details": "Контактные данные",
          "object": "Данные по покрытию",
          "extra": "Дополнительная информация"
        },
        "applicant": {
          "title": "Кто подаёт заявку на страхование?",
          "description": "Это определяет, какую информацию мы спросим на следующих шагах.",
          "legend": "Тип заявителя",
          "individual_title": "Физическое лицо",
          "individual_description": "Авто, жильё, поездки, здоровье и другие личные риски.",
          "company_title": "Юридическое лицо",
          "company_description": "Имущество компании, ответственность, сотрудники и грузы."
        },
        "insurance": {
          "title": "Что вы хотите застраховать?",
          "description": "Показываем только виды, которые соответствуют выбранному типу заявителя. Если подходящего нет, выберите «Другое».",
          "label": "Вид страхования",
          "search": "Искать вид страхования…",
          "selected": "Выбрано: %{name}. На следующем шаге «данные по покрытию» спросим только то, что нужно для подготовки предложения."
        },
        "details": {
          "individual_title": "Ваши контактные данные",
          "company_title": "Данные компании",
          "description": "Эти данные используем только для подготовки предложения и связи.",
          "first_name": "Имя",
          "last_name": "Фамилия",
          "personal_code": "Персональный код",
          "personal_code_hint": "Необходим для точной подготовки страхового предложения.",
          "personal_code_placeholder": "123456-12345",
          "city": "Город",
          "company_name": "Название компании",
          "registration_number": "Регистрационный номер",
          "registration_placeholder": "40003000000",
          "contact_person": "Контактное лицо",
          "employee_count": "Количество сотрудников",
          "industry": "Отрасль",
          "industry_placeholder": "Например, строительство или торговля",
          "phone": "Телефон",
          "phone_placeholder": "20000000",
          "email": "Эл. почта",
          "email_placeholder": "name@example.com"
        },
        "object": {
          "title": "Информация, специфичная для страхования",
          "description_named": "Эти поля относятся к %{name}. Если чего-то точно не знаете, укажите примерно — консультант уточнит.",
          "description": "Если чего-то точно не знаете, укажите примерно — консультант уточнит."
        },
        "extra": {
          "title": "Дополнительная информация",
          "description": "Расскажите, если есть что-то особенное — например, действующий полис, желаемая франшиза или срок.",
          "message": "Комментарии",
          "message_placeholder": "Например: текущий полис заканчивается 1 марта, хочу меньшую франшизу.",
          "consent_before": "Соглашаюсь, что мои данные обрабатываются для подготовки страхового предложения в соответствии с ",
          "consent_link": "политикой конфиденциальности",
          "consent_after": ".",
          "marketing": "Хочу получать информацию о предложениях и сроках продления полисов."
        }
      },
      "validation": {
        "applicant_type": "Выберите тип заявителя",
        "insurance_type": "Выберите вид страхования",
        "insurance_type_available": "Выберите доступный вид страхования",
        "first_name": "Укажите имя",
        "first_name_short": "Имя должно содержать не менее 2 символов",
        "last_name": "Укажите фамилию",
        "last_name_short": "Фамилия должна содержать не менее 2 символов",
        "personal_code": "Проверьте персональный код",
        "city_short": "Название города должно содержать не менее 2 символов",
        "company_name": "Укажите название компании",
        "company_name_short": "Название должно содержать не менее 2 символов",
        "registration_number": "Укажите регистрационный номер",
        "contact_person": "Укажите контактное лицо",
        "contact_person_short": "Имя контактного лица должно содержать не менее 2 символов",
        "employee_count": "Количество сотрудников должно быть не менее 1",
        "phone": "Укажите номер телефона",
        "phone_invalid": "Проверьте номер телефона (например, +37120000000)",
        "email": "Укажите адрес эл. почты",
        "email_invalid": "Проверьте адрес эл. почты",
        "field_required": "Укажите: %{label}",
        "number": "Укажите число",
        "consent": "Необходимо согласие на обработку данных"
      },
      "select": {
        "placeholder": "Выберите…",
        "search": "Искать…",
        "no_results": "Нет результатов",
        "search_field": "Искать: %{label}…"
      },
      "phone": {
        "country_code": "Код страны",
        "countries": {
          "+371": "Латвия",
          "+372": "Эстония",
          "+370": "Литва",
          "+358": "Финляндия",
          "+46": "Швеция",
          "+47": "Норвегия",
          "+45": "Дания",
          "+49": "Германия",
          "+48": "Польша",
          "+7": "Россия",
          "+1": "США",
          "+44": "Великобритания",
          "+33": "Франция",
          "+39": "Италия",
          "+34": "Испания"
        }
      },
      "breadcrumbs": {
        "location": "Вы здесь"
      },
      "dates": {
        "locale": "ru-RU",
        "year_suffix": ""
      }
    }
  }
}
